module.exports = __webpack_public_path__ + "static/media/showroom-background-3.eeebe5bd.jpg";